import React from "react";
import Checkbox from "@mui/material/Checkbox";

import { useSelector, useDispatch } from "react-redux";

function HeaderCheckbox() {
  const dispatch = useDispatch();
  const idsOfFilteredData = useSelector((state) => state.idsOfFilteredData);
  const idsOfItemsInStagingArea = useSelector(
    (state) => state.idsOfItemsInStagingArea
  );

  const shouldBeChecked = (idsOfFilteredData, idsOfItemsInStagingArea) => {
    let shouldBeChecked = true;
    for (const id of idsOfFilteredData) {
      if (!idsOfItemsInStagingArea.includes(id)) {
        shouldBeChecked = false;
        return shouldBeChecked;
      }
    }
    return shouldBeChecked;
  };

  const checked = shouldBeChecked(idsOfFilteredData, idsOfItemsInStagingArea);

  const handleClick = () => {
    if (checked) {
      dispatch({ type: "RESET_IDS_OF_ITEMS_IN_STAGING_AREA" });
    } else {
      const newIdsOfItemsInStagingArea = Array.from(
        new Set([...idsOfItemsInStagingArea, ...idsOfFilteredData])
      );

      dispatch({
        type: "SET_IDS_OF_ITEMS_IN_STAGING_AREA",
        payload: newIdsOfItemsInStagingArea,
      });
    }
  };

  return (
    <Checkbox
      size="small"
      sx={{ width: 10, height: 10 }}
      checked={checked}
      onClick={handleClick}
    />
  );
}

export default HeaderCheckbox;
